/**
 * Manually configure the webpack publicPath so it pulls everything in from the current environment's CDN
 *
 * TODO this feels really smelly.
 * Ideally we'd set the __webpack_public_path__ from the config.uris.cdn value but it's not working for image assets.
 * They seem to be getting imported before the config is loaded and that value can be set.
 */
let target = window.location.origin;
if ((!target || target === 'null') && window.location.ancestorOrigins?.length) {
  [target] = window.location.ancestorOrigins;
}

const pattern = /https?:\/\/((\w+)(-\w+)?)(\.dev)?\.(\w+)\.com/i;
if (pattern.test(target)) {
  const [, replaceable, env, , dev] = target.match(pattern);
  target = target.replace(replaceable, dev ? `${env}-cdn` : 'cdn');
  // eslint-disable-next-line camelcase,no-undef
  __webpack_public_path__ = `${target}${process.env.PUBLIC_URL}`;
}
